import type { StateCreator } from "../store";
import type { AppStore } from "../index";

// KeyPair type compatible with switch-core
export interface KeyPair {
  publicKey: Uint8Array;
  secretKey: Uint8Array;
}

export interface EncryptionKeyPair {
  cryptoKeys: KeyPair;
  base64: {
    publicKey: string;
    secretKey: string;
  };
}

export interface EncryptionSlice {
  // State
  keyPair: EncryptionKeyPair | undefined;
  mlKemKeyPair: EncryptionKeyPair | undefined;
  displayPhotoKey: string | undefined;
  coverPhotoKey: string | undefined;
  profileKey: string | undefined;

  // Actions
  setKeyPair: (keyPair: EncryptionKeyPair | undefined) => void;
  setMlKemKeyPair: (keyPair: EncryptionKeyPair | undefined) => void;
  setDisplayPhotoKey: (key: string | undefined) => void;
  setCoverPhotoKey: (key: string | undefined) => void;
  setProfileKey: (key: string | undefined) => void;
}

export const createEncryptionSlice: StateCreator<AppStore, unknown, unknown, EncryptionSlice> = (set) => ({
  // Initial state
  keyPair: undefined,
  mlKemKeyPair: undefined,
  displayPhotoKey: undefined,
  coverPhotoKey: undefined,
  profileKey: undefined,

  // Actions
  setKeyPair: (keyPair) =>
    set((state) => {
      state.keyPair = keyPair;
    }),

  setMlKemKeyPair: (keyPair) =>
    set((state) => {
      state.mlKemKeyPair = keyPair;
    }),

  setDisplayPhotoKey: (key) =>
    set((state) => {
      state.displayPhotoKey = key;
    }),

  setCoverPhotoKey: (key) =>
    set((state) => {
      state.coverPhotoKey = key;
    }),

  setProfileKey: (key) =>
    set((state) => {
      state.profileKey = key;
    }),
});
